import { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { isEmbed } from 'routes';
import { useSelector } from 'react-redux';
import './styles.scss';

function ChatBot({ isAuthenticated }) {
  const user = useSelector(state => state.session.user);
  const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_KEY || 'c6fefc9d-c7d6-418f-a5e6-4ea6d2c5e001';

  const toggleZendeskVisibility = useCallback((visible) => {
    try {
      const zendeskUI = document.getElementById('launcher')?.parentElement?.parentElement;
      if (zendeskUI) {
        zendeskUI.style.visibility = visible ? 'visible' : 'hidden';
      }
    } catch (error) {
      console.error('Error toggling Zendesk visibility:', error);
    }
  }, []);

  const handleClickOutside = useCallback((event) => {
    try {
      const zendeskFrame = document.querySelector('iframe[data-product="web_widget"]');
      const zendeskLauncher = document.getElementById('launcher');

      if (zendeskFrame
          && !zendeskFrame.contains(event.target)
          && !zendeskLauncher?.contains(event.target)
          && window.zE) {
        window.zE('messenger', 'close');
      }
    } catch (error) {
      console.error('Error handling outside click:', error);
    }
  }, []);

  useEffect(() => {
    if (!isAuthenticated || isEmbed()) return () => {};

    const initializeZendesk = () => {
      if (window.zE) {
        window.zE('messenger:set', 'conversationFields', [
          { id: '18749392792348', value: user.firstname },
        ]);
        window.zE('messenger:set', 'conversationTags', ['sland']);
      }
    };

    if (!document.getElementById('ze-snippet')) {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
      script.async = true;
      script.onload = initializeZendesk;
      script.onerror = (error) => console.error('Failed to load Zendesk:', error);
      document.body.appendChild(script);
    } else {
      toggleZendeskVisibility(true);
      initializeZendesk();
    }

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      toggleZendeskVisibility(false);
    };
  }, [isAuthenticated, handleClickOutside, toggleZendeskVisibility, user, ZENDESK_KEY]);

  return null;
}

ChatBot.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

export default ChatBot;
